"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var es6_promise_1 = require("es6-promise");
var AdobeEvent_1 = require("./AdobeEvent");
var endPoints_constant_1 = require("./constants/endPoints.constant");
var LocalStorageService_1 = require("./services/LocalStorageService");
var PageLoadDataService_1 = require("./services/PageLoadDataService");
var WindowService_1 = require("./services/WindowService");
(0, es6_promise_1.polyfill)();
var IigAdobeLaunch = (function () {
    function IigAdobeLaunch() {
        var _this = this;
        this.localStorageService = new LocalStorageService_1.default();
        this.userDetailsUrl = '';
        this.loggedOnUrl = '';
        this.isSPAViewTracked = false;
        this.spaEvent = {};
        if (typeof window === 'undefined') {
            setTimeout(function () {
                _this.loggedOnUrl = IigAdobeLaunch.getIsLoggedInUrl();
                _this.userDetailsUrl = IigAdobeLaunch.getUserDetailsUrl();
            }, 10);
        }
        else {
            this.loggedOnUrl = IigAdobeLaunch.getIsLoggedInUrl();
            this.userDetailsUrl = IigAdobeLaunch.getUserDetailsUrl();
        }
        setTimeout(function () {
            if (window) {
                if (window.addEventListener) {
                    window.addEventListener('load', function () {
                        IigAdobeLaunch.addObserver();
                    });
                }
                if (window.sessionStorage && window.sessionStorage.setItem) {
                    IigAdobeLaunch.isLoggedOnUrl = IigAdobeLaunch.getIsLoggedInUrl();
                    IigAdobeLaunch.userDetailServiceUrl = IigAdobeLaunch.getUserDetailsUrl();
                    window.sessionStorage.setItem('isLoggedOnUrl', IigAdobeLaunch.isLoggedOnUrl);
                    window.sessionStorage.setItem('userDetailServiceUrl', IigAdobeLaunch.userDetailServiceUrl);
                }
            }
        }, 1000);
        this.scheduleAdobeTrackingTaskRegistration(0, 2000);
    }
    IigAdobeLaunch.isInternal = function () {
        return document.URL.indexOf('iami') > -1;
    };
    IigAdobeLaunch.getNavigationTopMenu = function (subMenuElemArg) {
        var result;
        var topMenuList = document
            .getElementById(this.GLOBAL_HDR_CONTAINER_ID)
            .querySelectorAll('ul.vgn-highLevelNav > li > a');
        topMenuList.forEach(function (topMenuElem) {
            var subMenuTempList = topMenuElem.parentNode.querySelectorAll('li > a.vgn-sectionLink');
            subMenuTempList.forEach(function (subMenuTempElem) {
                if (subMenuElemArg === subMenuTempElem.textContent) {
                    result = topMenuElem.textContent;
                }
            });
        });
        return result;
    };
    IigAdobeLaunch.getServiceBaseHost = function () {
        if (IigAdobeLaunch.isInternal()) {
            return document.URL.indexOf('/iami.vanguard.com') > -1
                ? endPoints_constant_1.default.WEB_SERVICE_PROD_INTERNAL
                : endPoints_constant_1.default.WEB_SERVICE_SAT_INTERNAL;
        }
        else {
            return document.URL.indexOf('/institutional.vanguard.com') > -1
                ? endPoints_constant_1.default.WEB_SERVICE_PROD
                : endPoints_constant_1.default.WEB_SERVICE_SAT;
        }
    };
    IigAdobeLaunch.getAppBaseHost = function () {
        if (this.isInternal()) {
            return document.URL.indexOf('/iami.vanguard.com') > -1
                ? endPoints_constant_1.default.BASE_HOST_PROD_INTERNAL
                : endPoints_constant_1.default.BASE_HOST_SAT_INTERNAL;
        }
        else {
            return document.URL.indexOf('/institutional.vanguard.com') > -1
                ? endPoints_constant_1.default.BASE_HOST_PROD
                : endPoints_constant_1.default.BASE_HOST_SAT;
        }
    };
    IigAdobeLaunch.getIsLoggedInUrl = function () {
        var logOnEndPoint;
        if (/MSIE|Trident/.test(window.navigator.userAgent)) {
            logOnEndPoint = endPoints_constant_1.default.LOGGED_ON_STATUS_IE;
        }
        else {
            logOnEndPoint = endPoints_constant_1.default.LOGGED_ON_STATUS;
        }
        return IigAdobeLaunch.getAppBaseHost() + logOnEndPoint;
    };
    IigAdobeLaunch.getUserDetailsUrl = function () {
        return IigAdobeLaunch.getServiceBaseHost() + endPoints_constant_1.default.USER_DETAIL_SERVICE;
    };
    IigAdobeLaunch.addObserver = function () {
        var trackAutoSuggestEvents = function (e) {
            var searchQuery = document.querySelector('#vgn-subUtilityBarSearchInput');
            var searchQueryVal = searchQuery.value;
            var linkIndex = Array.prototype.indexOf.call(document.querySelectorAll('li.vgn-searchResult'), e.target.parentNode);
            var autoSuggestAdobeData = {
                internalSearchQuery: searchQueryVal,
                autoSuggestPosition: linkIndex + 1,
                internalSearchConducted: '1',
                autoSuggestSelected: 1
            };
            var resultClickedArray = document.querySelectorAll('li.vgn-searchResult');
            var resultClickedArrayIndex = resultClickedArray[linkIndex];
            var resultClickedArrayIndexInnerText = resultClickedArrayIndex.innerText;
            window.sessionStorage.setItem('searchType', 'autosuggest');
            window.dataLayer.push({
                event: 'searchConducted',
                searchInfo: {
                    searchTermEntered: autoSuggestAdobeData.internalSearchQuery,
                    resultClicked: resultClickedArrayIndexInnerText,
                    searchType: 'autosuggest'
                }
            });
        };
        function observeAutoSuggest() {
            var observer = new MutationObserver(function () {
                document
                    .querySelectorAll('.vgn-subUtilityBar .vgn-autoSuggest a:not(.vgn-displayNone)')
                    .forEach(function (link) {
                    if (link.onclick === null) {
                        link.onclick = trackAutoSuggestEvents;
                    }
                });
            });
            var config = {
                childList: true
            };
            if (document.querySelector('.vgn-subUtilityBar .vgn-autoSuggest')) {
                var target = document.querySelector('.vgn-subUtilityBar .vgn-autoSuggest');
                observer.observe(target, config);
            }
        }
        setTimeout(function () {
            document.addEventListener('click', function (e) {
                if (e.target.id === 'vgn-subUtilityBarSearchInput') {
                    observeAutoSuggest();
                }
                if (e.target.id === 'vgn-subUtilityBarSearchSubmitButton') {
                    var searchValueElement = document.querySelector('#vgn-subUtilityBarSearchInput');
                    var searchValue = searchValueElement.value;
                    window.sessionStorage.setItem('searchType', 'global');
                    window.dataLayer.push({
                        event: 'searchConducted',
                        searchInfo: {
                            searchTermEntered: searchValue,
                            searchType: 'global'
                        }
                    });
                }
            });
            observeAutoSuggest();
        }, 3000);
    };
    IigAdobeLaunch.prototype.scheduleAdobeTrackingTaskRegistration = function (attemptCount, timeoutVal) {
        var _this = this;
        setTimeout(function () {
            var isTempGlobalNavLinkRegisteredForTrackingFlag = _this.adobeTrackingTaskRegistration();
            if (attemptCount < 5 &&
                isTempGlobalNavLinkRegisteredForTrackingFlag === false) {
                var tempAttemptCount = attemptCount + 1;
                console.log('*Failure : Event Registration  with global Nav link is Failed, Re attempt count [' +
                    tempAttemptCount +
                    ']');
                _this.scheduleAdobeTrackingTaskRegistration(tempAttemptCount, 1000);
            }
            else {
                console.log('Event Registration  with global Nav link : Success !!');
            }
        }, timeoutVal);
    };
    IigAdobeLaunch.prototype.getLocalStorageService = function () {
        return this.localStorageService;
    };
    IigAdobeLaunch.prototype.clearOffPrevEvents = function () {
        if (window && window.dataLayer) {
            if (window.dataLayer.length > 0 &&
                window.dataLayer[0].event === 'spaView') {
                this.spaEvent = window.dataLayer[0];
            }
            if (window.dataLayer._reset) {
                window.dataLayer._reset();
            }
        }
    };
    IigAdobeLaunch.prototype.trackEvent = function (eventName, eventDataName, eventData, reportQuantity) {
        var adobeEvent = new AdobeEvent_1.default(eventName, eventDataName, eventData, reportQuantity);
        WindowService_1.default.pushToDatalayer(adobeEvent.getData());
    };
    IigAdobeLaunch.prototype.trackSPAEvent = function (eventName, eventDataName, eventData, reportQuantity) {
        var adobeEvent = new AdobeEvent_1.default(eventName, eventDataName, eventData, reportQuantity);
        this.isSPAViewTracked = true;
        var eventValue = adobeEvent.getData();
        WindowService_1.default.pushToDatalayer(eventValue);
    };
    IigAdobeLaunch.prototype.trackDelayedEvent = function (eventName, eventDataName, eventData, reportQuantity) {
        var adobeEvent = new AdobeEvent_1.default(eventName, eventDataName, eventData, reportQuantity);
        this.localStorageService.addEventDataItem(adobeEvent);
    };
    IigAdobeLaunch.prototype.trackFormStarted = function (formName) {
        var formStartedObject = {
            formName: formName
        };
        this.trackEvent('formStarted', 'form', formStartedObject);
    };
    IigAdobeLaunch.prototype.trackFormAbandoned = function (formName, formAbandonmentField, formAbandonmentType) {
        var formAbandonedObject = {
            formName: formName,
            formAbandonmentField: formAbandonmentField,
            formAbandonmentType: formAbandonmentType
        };
        this.trackEvent('formAbandoned', 'form', formAbandonedObject);
    };
    IigAdobeLaunch.prototype.trackFormSubmitted = function (formName) {
        var formSubmittedObject = {
            formName: formName
        };
        this.trackEvent('formSubmitted', 'form', formSubmittedObject);
    };
    IigAdobeLaunch.prototype.trackSearchResultClicked = function (searchClickedObject) {
        this.trackEvent('searchResultClicked', 'searchInfo', searchClickedObject);
    };
    IigAdobeLaunch.prototype.trackSearchResultsReached = function (searchResultsObject) {
        this.trackDelayedEvent('searchResultsReached', 'searchInfo', searchResultsObject);
    };
    IigAdobeLaunch.prototype.trackSubscriptionInitiated = function (subscriptionObject) {
        this.trackEvent('subscriptionInitiated', 'subscription', subscriptionObject);
    };
    IigAdobeLaunch.prototype.trackSubscriptionActivated = function (subscriptionObject) {
        this.trackEvent('subscriptionActivated', 'subscription', subscriptionObject);
    };
    IigAdobeLaunch.prototype.trackSubscriptionManaged = function (subscriptionObject) {
        this.trackEvent('subscriptionManaged', 'subscription', subscriptionObject);
    };
    IigAdobeLaunch.prototype.trackSubscriptionUnsubscribed = function (subscriptionObject) {
        this.trackEvent('subscriptionUnsubscribed', 'subscription', subscriptionObject);
    };
    IigAdobeLaunch.prototype.trackLocalStorageEvents = function () {
        var eventDataItems = this.localStorageService.get();
        for (var _i = 0, eventDataItems_1 = eventDataItems; _i < eventDataItems_1.length; _i++) {
            var eventDataItem = eventDataItems_1[_i];
            WindowService_1.default.pushToDatalayer(eventDataItem);
        }
        this.localStorageService.clear();
    };
    IigAdobeLaunch.prototype.trackSubpageViewed = function (subPageID, spClicked) {
        this.trackEvent('subPageViewed', 'subPage', { subPageID: subPageID, spClicked: spClicked });
    };
    IigAdobeLaunch.prototype.trackContentShared = function (shareType, linkName) {
        this.trackEvent('contentShared', 'medium', { shareType: shareType, linkName: linkName });
    };
    IigAdobeLaunch.prototype.trackContentDownloaded = function (fileName, fileLocation) {
        var contentData = { fileName: fileName, fileLocation: fileLocation };
        this.trackEvent('contentDownloaded', 'linkInfo', contentData);
    };
    IigAdobeLaunch.prototype.trackMultipleContentDownloaded = function (fileArray) {
        this.trackEvent('contentDownloaded', 'linkInfo', fileArray);
    };
    IigAdobeLaunch.prototype.trackCallToAction = function (ctaName, location, ctaType) {
        var callToActionObject = {
            ctaName: ctaName,
            location: location,
            ctaType: ctaType
        };
        this.trackEvent('callToAction', 'callToAction', callToActionObject);
    };
    IigAdobeLaunch.prototype.trackProcessStart = function (processObject) {
        this.trackDelayedEvent('processStart', 'process', processObject);
    };
    IigAdobeLaunch.prototype.trackProcessCommit = function (processObject) {
        this.trackDelayedEvent('processCommit', 'process', processObject);
    };
    IigAdobeLaunch.prototype.trackProcessSideStepSuccess = function (processObject) {
        this.trackDelayedEvent('processSideStepSuccess', 'process', processObject);
    };
    IigAdobeLaunch.prototype.trackReportAdded = function (reportArray) {
        this.trackEvent('reportAdded', 'report', reportArray);
    };
    IigAdobeLaunch.prototype.trackReportRemoved = function (reportArray) {
        this.trackEvent('reportRemoved', 'report', reportArray);
    };
    IigAdobeLaunch.prototype.trackReportPreviewed = function (data) {
        var updatedProperties = ['reportPreviewQuantity'];
        var reportArray = data.report;
        var reportQtyObj = {};
        for (var _i = 0, updatedProperties_1 = updatedProperties; _i < updatedProperties_1.length; _i++) {
            var prop = updatedProperties_1[_i];
            reportQtyObj[prop] = data[prop];
        }
        this.trackDelayedEvent('reportPreviewed', 'report', reportArray, reportQtyObj);
    };
    IigAdobeLaunch.prototype.trackReportGenerated = function (data) {
        var generatedProperties = ['reportGeneratedQuantity'];
        var reportArray = data.report;
        var reportQtyObj = {};
        for (var _i = 0, generatedProperties_1 = generatedProperties; _i < generatedProperties_1.length; _i++) {
            var prop = generatedProperties_1[_i];
            reportQtyObj[prop] = data[prop];
        }
        this.trackEvent('reportGenerated', 'report', reportArray, reportQtyObj);
    };
    IigAdobeLaunch.prototype.trackAccordionClick = function (accordionName) {
        var accordianClickObject = {
            accordionName: accordionName
        };
        this.trackEvent('accordionClick', 'accordion', accordianClickObject);
    };
    IigAdobeLaunch.prototype.trackAdvertisingDoubleClick = function (data) {
        this.trackEvent('advertising_doubleClick', 'dcf_page', data);
    };
    IigAdobeLaunch.prototype.trackReportViewed = function (reportArray) {
        this.trackDelayedEvent('reportViewed', 'report', reportArray);
    };
    IigAdobeLaunch.prototype.trackReportViewedWithoutPageLoad = function (data) {
        if (data.reportViewed) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push(data.reportViewed);
        }
    };
    IigAdobeLaunch.prototype.trackPageLoadEvent = function (data) {
        var pageData = PageLoadDataService_1.default.buildPageData(data);
        this.trackEvent('pageLoaded', 'page', pageData);
    };
    IigAdobeLaunch.prototype.trackPageLoadCompleted = function () {
        this.trackEvent('pageLoadCompleted');
    };
    IigAdobeLaunch.prototype.getPageName = function () {
        return PageLoadDataService_1.default.pageName;
    };
    IigAdobeLaunch.prototype.initializePage = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var clickedNavLinkDetailStr, clickedNavLinkDetailObj, abodeTrackerObj;
            return __generator(this, function (_a) {
                if (!this.isSPAViewTracked) {
                    this.clearOffPrevEvents();
                }
                this.trackPageLoadEvent(data);
                if (data.userDetected) {
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push(data.userDetected);
                }
                this.trackLocalStorageEvents();
                if (data.reportPreViewed) {
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push(data.reportPreViewed);
                }
                if (data.searchResultReached) {
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        event: 'searchResultsReached',
                        searchInfo: data.searchResultReached
                    });
                }
                if (data.subPageId) {
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        event: 'subPageViewed',
                        subPage: {
                            subPageID: data.subPageId,
                            spClicked: data.spClicked
                        }
                    });
                }
                if (data.reportViewed) {
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push(data.reportViewed);
                }
                clickedNavLinkDetailStr = sessionStorage.getItem('ClickedNavLinkDetail');
                if (clickedNavLinkDetailStr) {
                    clickedNavLinkDetailObj = JSON.parse(clickedNavLinkDetailStr);
                    abodeTrackerObj = {
                        navigationMenuItem: clickedNavLinkDetailObj.navigationLinkClicked,
                        navigationLinkClicked: clickedNavLinkDetailObj.navigationMenuItem,
                        currentPageName: this.getPageName()
                    };
                    if (clickedNavLinkDetailObj &&
                        (clickedNavLinkDetailObj.navigationLinkClickedHref === window.location.href
                            || window.location.href.indexOf("subscription") !== -1)) {
                        this.trackEvent('navigationClicks', 'navigation', abodeTrackerObj);
                    }
                    sessionStorage.removeItem('ClickedNavLinkDetail');
                }
                this.trackPageLoadCompleted();
                this.isSPAViewTracked = false;
                return [2];
            });
        });
    };
    IigAdobeLaunch.prototype.adobeTrackingTaskRegistration = function () {
        var isGlobalNavLinkRegisteredForTrackingFlag = false;
        if (document.getElementById(IigAdobeLaunch.GLOBAL_HDR_CONTAINER_ID)) {
            var subMenuList = document
                .getElementById(IigAdobeLaunch.GLOBAL_HDR_CONTAINER_ID)
                .querySelectorAll('a');
            subMenuList.forEach(function (subMenuElem) {
                if (subMenuElem.classList.contains('vgn-sectionLink') ||
                    subMenuElem.classList.contains('vgn-plainLink')) {
                    subMenuElem.addEventListener('click', function (e) {
                        var topMenuName = IigAdobeLaunch.getNavigationTopMenu(subMenuElem.text);
                        var navLinkObj = {
                            navigationLinkClicked: topMenuName,
                            navigationMenuItem: subMenuElem.text,
                            navigationLinkClickedHref: subMenuElem.href
                        };
                        sessionStorage.setItem('ClickedNavLinkDetail', JSON.stringify(navLinkObj));
                    });
                    isGlobalNavLinkRegisteredForTrackingFlag = true;
                }
            });
        }
        return isGlobalNavLinkRegisteredForTrackingFlag;
    };
    IigAdobeLaunch.userDetailServiceUrl = '';
    IigAdobeLaunch.isLoggedOnUrl = '';
    IigAdobeLaunch.GLOBAL_HDR_CONTAINER_ID = 'vgn-globalHeader';
    return IigAdobeLaunch;
}());
exports.default = IigAdobeLaunch;
